import { render, staticRenderFns } from "./pcVideoLive.vue?vue&type=template&id=004f882a&scoped=true"
import script from "./pcVideoLive.vue?vue&type=script&lang=js"
export * from "./pcVideoLive.vue?vue&type=script&lang=js"
import style0 from "./pcVideoLive.vue?vue&type=style&index=0&id=004f882a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f882a",
  null
  
)

export default component.exports